import React from 'react';
import { motion } from 'framer-motion';
import { HiMail, HiLocationMarker } from 'react-icons/hi';
import { FaLinkedin, FaGithub } from 'react-icons/fa';
import { useLanguage } from '../i18n/LanguageContext';
import './Contact.css';

const Contact = () => {
  const { t } = useLanguage();

  return (
    <section className="contact section" id="contact">
      <div className="container">
        <motion.div
          className="contact__header"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
        >
          <span className="section-label">{t('contact.label')}</span>
          <h2 className="section-title">
            {t('contact.titleStart')}<span className="gradient-text">{t('contact.titleHighlight')}</span>
          </h2>
          <p className="section-subtitle">{t('contact.subtitle')}</p>
        </motion.div>

        <div className="contact__content">
          <motion.div
            className="contact__info"
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="contact__info-cards">
              <motion.a
                href="mailto:giuseppe.monfregola.98@gmail.com"
                className="contact__info-card"
                whileHover={{ y: -4, borderColor: 'rgba(0, 212, 170, 0.3)' }}
              >
                <div className="contact__info-icon">
                  <HiMail />
                </div>
                <div>
                  <h4>Email</h4>
                  <p>giuseppe.monfregola.98@gmail.com</p>
                </div>
              </motion.a>

              <motion.div
                className="contact__info-card"
                whileHover={{ y: -4, borderColor: 'rgba(0, 212, 170, 0.3)' }}
              >
                <div className="contact__info-icon">
                  <HiLocationMarker />
                </div>
                <div>
                  <h4>Location</h4>
                  <p>Napoli, Italia</p>
                </div>
              </motion.div>
            </div>

            <div className="contact__socials">
              <p className="contact__socials-label">{t('contact.followMe')}</p>
              <div className="contact__socials-links">
                <motion.a
                  href="https://www.linkedin.com/in/giuseppe-monfregola-65a110164/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact__social-link"
                  whileHover={{ y: -4, backgroundColor: 'rgba(0, 212, 170, 0.12)' }}
                  aria-label="LinkedIn"
                >
                  <FaLinkedin />
                </motion.a>
                <motion.a
                  href="https://github.com/Giusmonf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="contact__social-link"
                  whileHover={{ y: -4, backgroundColor: 'rgba(0, 212, 170, 0.12)' }}
                  aria-label="GitHub"
                >
                  <FaGithub />
                </motion.a>
              </div>
            </div>
          </motion.div>

          <motion.div
            className="contact__cta"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <div className="contact__cta-card">
              <div className="contact__cta-icon">🎮</div>
              <h3>{t('contact.ctaTitle')}</h3>
              <p>{t('contact.ctaDesc')}</p>
              <motion.a
                href="mailto:giuseppe.monfregola.98@gmail.com"
                className="contact__cta-btn"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <HiMail /> {t('contact.ctaBtn')}
              </motion.a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
